<script setup lang="ts">
import { computed } from 'vue';
import { RouterLink, useRouter, type RouteLocationRaw } from 'vue-router';

const router = useRouter();

const props = withDefaults(
  defineProps<{
    to?: RouteLocationRaw | string;
    rowClass?: string;
  }>(),
  {
    to: undefined,
    rowClass: undefined,
  },
);

const emit = defineEmits<{
  (e: 'click', event: MouseEvent): void;
  (e: 'click-middle', event: MouseEvent): void;
}>();

const isRouterLink = computed(() => {
  if (!props.to) {
    return false;
  }

  const route = router.resolve(props.to);
  return route.name !== 'error.404';
});

const component = computed(() => {
  return isRouterLink.value ? RouterLink : 'a';
});

const linkProps = computed(() => {
  if (isRouterLink.value) {
    return {
      to: props.to,
    };
  }

  return {
    href: props.to,
    target: '_blank',
  };
});

const handleClick = (event: MouseEvent) => {
  emit('click', event);
};

const handleMiddleClick = (event: MouseEvent) => {
  emit('click-middle', event);
};
</script>

<template>
  <Component
    :is="component"
    v-bind="linkProps"
    :class="rowClass"
    @click="handleClick"
    @click.middle="handleMiddleClick"
  >
    <slot />
  </Component>
</template>
